import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import BooksOutlineButton, {
  Sizing,
} from '../common/buttons/BooksOutlineButton';
import BooksMenu from './BooksMenu';
import css from './BooksSelectedMenu.module.scss';

interface OwnProps {
  className?: string;
  changeTarget: () => void;
  changeOption?: () => void;
}

interface Renderable {
  name: string;
  duration?: number; // second
  price?: string;
  options: Array<{
    name: string;
    price: string;
  }>;
}

type Props = OwnProps & Renderable & InjectedIntlProps;

const BooksSelectedMenu = ({
  className,
  intl,
  options,
  changeTarget,
  changeOption,
  ...props
}: Props) => {
  const classes = classNames(css.BooksSelectedMenu, className);

  return (
    <div className={classes}>
      <div className={css.BooksSelectedMenu__Item}>
        <BooksMenu
          className={css.BooksSelectedMenu__Menu}
          menuName={props.name}
          duration={props.duration}
          price={props.price}
        />
        <BooksOutlineButton
          className={css.BooksSelectedMenu__Button}
          sizing={Sizing.Small}
          children={intl.formatMessage({ id: 'books.button.change' })}
          onClick={changeTarget}
        />
      </div>
      {options.length > 0 && (
        <div className={css.BooksSelectedMenu__Item}>
          <ul className={css.BooksSelectedMenu__Options}>
            {options.map((option, index) => (
              <li key={index} className={css.BooksSelectedMenu__OptionsItem}>
                <span className={css.BooksSelectedMenu__OptionsName}>
                  {option.name}
                </span>
                <span className={css.BooksSelectedMenu__OptionsPrice}>
                  <FormattedMessage
                    id="books.optionsList.price"
                    values={{ price: option.price }}
                  />
                </span>
              </li>
            ))}
          </ul>
          <BooksOutlineButton
            className={css.BooksSelectedMenu__Button}
            sizing={Sizing.Small}
            children={intl.formatMessage({ id: 'books.button.change' })}
            onClick={changeOption}
          />
        </div>
      )}
    </div>
  );
};

export default injectIntl(BooksSelectedMenu);
